<template>
  <div class="organizer-container">
    <text-field
      v-model.trim="form.publicName"
      :validator="vs.form.publicName"
      label="Organization public name"
    />
    <!--    <div class="select-type-field">
      <select-field
        v-model="form.type"
        label="Organization type"
        :validator="vs.form.type"
        :items="organizationTypes"
      />
      <button class="type-info-button" @click="isOrganizationTypeDescriptionModalOpen = true">
        <img src="/assets/info-rounded.svg" alt="info button" />
      </button>
    </div>-->
    <text-field v-model.trim="form.email" :validator="vs.form.email" label="Email" />
    <div class="organizer-info">
      <logo-field v-model="form.logo" class="logo" />
      <textarea-field
        v-model="form.description"
        label="Organizer description"
        :validator="vs.form.description"
      />
    </div>
    <text-field v-model="form.webLink" label="Web link" />
    <div class="links">
      <text-field v-model="form.facebookLink" label="Facebook link" />
      <text-field v-model="form.instagramLink" label="Instagram link" />
    </div>
    <organization-type-description-modal
      v-if="isOrganizationTypeDescriptionModalOpen"
      @closeModal="isOrganizationTypeDescriptionModalOpen = false"
    />
  </div>
</template>

<script>
import { OrganizationType } from '@/types'
import { capitalize } from 'lodash'
import OrganizationTypeDescriptionModal from '@/components/organizations/organization-type-description-modal.vue'

export default {
  name: 'organization-info-form',
  components: { OrganizationTypeDescriptionModal },
  props: {
    initialValues: {
      type: Object,
      default: () => {},
    },
    vs: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: this.initialValues,
      organizationTypes: Object.values(OrganizationType).map(item =>
        capitalize(item.replace(/_/g, ' ')),
      ),
      isOrganizationTypeDescriptionModalOpen: false,
    }
  },
  computed: {
    OrganizationType() {
      return OrganizationType
    },
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('values', val)
      },
      deep: true,
    },
  },
}
</script>

<style scoped>
.organizer-container {
  display: flex;
  row-gap: 2rem;
  flex-direction: column;
}
.organizer-info {
  display: flex;
  flex-wrap: wrap;
  column-gap: 1.5rem;
}
.links {
  display: flex;
  column-gap: 1.5rem;
  flex-wrap: wrap;
}
.logo {
  margin: 0 auto;
}
.select-type-field {
  position: relative;
}
.type-info-button {
  position: absolute;
  right: 2.5rem;
  top: 1rem;
}
</style>
